import { IconHandbagSimple, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Tag } from '../../../Tag'
import { useNumbers } from '../../../utils/useNumbers'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { messages } from './messages'

type Props = {
  value: number | undefined
  onRemove: () => void
}

export function HistoricalPurchaseValueView(props: Props) {
  const { value, onRemove } = props

  const { formatCurrency } = useNumbers()
  const { $t } = useIntl()

  if (!value) return null

  return (
    <Rule>
      <RuleIcon>
        <IconHandbagSimple />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <Tag>{formatCurrency(value)}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
